/*
 * HFS a11y (ADA demand item c; audit PDP-13, JS-03, JS-15, CNT-15, TPL-19, GLB-28): one helper for every
 * in-page ("jump") link. The old handlers called preventDefault() and animated the scroll but never moved
 * focus, so keyboard and screen-reader users stayed on the link. This helper:
 *   1. opens a collapsed container first (PDP accordion item, <details>),
 *   2. scrolls the target below the sticky header (smooth, or instant under prefers-reduced-motion),
 *   3. moves focus to the target (or the first heading inside a section wrapper), adding tabindex="-1"
 *      when it is not focusable,
 *   4. updates the URL hash.
 * Returns false (and does nothing) when the target is missing or not rendered, so callers can fall back.
 * Usage: link.addEventListener('click', e => { if (window.hfsJumpTo(link.hash)) e.preventDefault(); });
 */
window.hfsJumpTo = function (target, options) {
  options = options || {};
  var el = target;
  if (typeof target === 'string') {
    var id = target.replace(/^#/, '');
    if (!id) return false;
    try { id = decodeURIComponent(id); } catch (err) { /* keep raw id */ }
    el = document.getElementById(id);
  }
  if (!el || !el.getClientRects) return false;

  // Open collapsed containers so the target is rendered and can take focus.
  var details = el.closest('details');
  while (details) {
    details.open = true;
    details = details.parentElement ? details.parentElement.closest('details') : null;
  }
  var accordionItem = el.closest('.accordion_item');
  if (accordionItem && typeof window.hfsSetAccordion === 'function') window.hfsSetAccordion(accordionItem, true, true);
  if (!el.getClientRects().length) return false;

  // Focus a heading, not a whole section wrapper (a focused wrapper makes screen readers read everything).
  var focusEl = el;
  if (!/^H[1-6]$/.test(el.tagName) && !el.matches('a[href], button, input, select, textarea, summary')) {
    focusEl = el.querySelector('h1, h2, h3, h4, h5, h6') || el;
  }
  if (!focusEl.matches('a[href], button, input, select, textarea, summary, [tabindex]')) focusEl.setAttribute('tabindex', '-1');
  focusEl.setAttribute('data-hfs-jump-target', '');

  var header = document.querySelector('.fixed-announce') || document.querySelector('.section-header');
  var offset = (header ? header.getBoundingClientRect().height : 0) + 12;
  document.documentElement.style.setProperty('--hfs-jump-offset', offset + 'px');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  focusEl.focus({ preventScroll: true });

  if (options.updateHash !== false && el.id && window.history && history.replaceState) {
    history.replaceState(history.state, '', '#' + el.id);
  }
  return true;
};

// header sticky
$(window).scroll(function () {
  if ($(window).scrollTop() > 40) {
    $('.fixed-announce').addClass('is-sticky');
    $('body').addClass('header_fixed');

  }
  else {
    $('.fixed-announce').removeClass('is-sticky');
    $('body').removeClass('header_fixed');
  }
});
// Document Ready Start
$(document).ready(function ($) {
  // add active link to child if grandchild is current
  $('.ctm_header-menu-grandchild').each(function () {
    if ($(this).hasClass('mega-menu__link--active')) {
      // console.log("has Class");
      $(this).parent('ul.list-unstyled').prev('.ctm_header-menu-child').addClass('mega-menu__link--active');
    } else {
      // console.log("Not has Class");
    }
  });

  /* HFS (JS-25/SRCH-26): removed the every-3-seconds-forever interval that classed Globo "#gf-form" inputs. The Globo
     filter app is not installed and nothing renders #gf-form, so it only polled. */

  // sitemap loadmore
  // HFS (FBL-020): bind click only (was 'click touchstart': acted on the touch-down event, WCAG 2.5.2, and could run twice on devices that fire both).
  $(function () {
    $(".ctm_sitemap_pages_list").slice(0, 20).show();
    $("body").on('click', '.load_more_pages', function (e) {
      e.preventDefault();
      // HFS a11y (JS-15): move focus to the first revealed item before the button disappears
      var $revealed = $(".ctm_sitemap_pages_list:hidden");
      $revealed.slideDown();
      $revealed.first().find('a').first().trigger('focus');
      $(".ctm_sitemap_pages_more").css('display', 'none'); // Assuming you 
    });
  });
  $(function () {
    $(".ctm_sitemap_collection_list").slice(0, 20).show();
    $("body").on('click', '.load_more_collection', function (e) {
      e.preventDefault();
      // HFS a11y (JS-15): move focus to the first revealed item before the button disappears
      var $revealed = $(".ctm_sitemap_collection_list:hidden");
      $revealed.slideDown();
      $revealed.first().find('a').first().trigger('focus');
      $(".ctm_sitemap_collection_more").css('display', 'none'); // Assuming you  
    });
  });
  $(function () {
    $(".ctm_sitemap_brands_list").slice(0, 20).show();
    $("body").on('click', '.load_more_brands', function (e) {
      e.preventDefault();
      // HFS a11y (JS-15): move focus to the first revealed item before the button disappears
      var $revealed = $(".ctm_sitemap_brands_list:hidden");
      $revealed.slideDown();
      $revealed.first().find('a').first().trigger('focus');
      $(".ctm_sitemap_braands_more").css('display', 'none'); // Assuming you 
    });
  });
  // HFS (final sweep): assets/hfs-carousel.js is deferred, so it has run by now (jQuery ready fires after deferred
  // scripts). If it bailed out (slick failed to load), use a no-op so the rest of this ready block still runs.
  if (typeof window.hfsCarousel !== 'function') window.hfsCarousel = function () {};
  // Main Banner slider
  window.hfsCarousel($('.main-banner .banner_listing'), {
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,

  }, { label: 'banner' });
  // Categories Slider
  window.hfsCarousel($('.our-categories .cat_listing'), {
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    variableWidth: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1460,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          variableWidth: false
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          variableWidth: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: false
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: false
        }
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false
        }
      }
    ]
  }, { label: 'categories' });
  // Brand Image Slider
  window.hfsCarousel($('.brand-img-slider .image_listing'), {
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      {
        breakpoint: 1460,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {

          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {

          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 430,
        settings: {

          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }, { label: 'popular brands' });
  /* Prodcut detail */
  // HFS a11y (PDP-14/JS-04/CSS-25): the accordion headers are <button aria-expanded aria-controls> inside the
  // <h2> (sections/product-accordion.liquid). Buttons give Enter/Space and focus for free; this keeps
  // aria-expanded, the .active class and the panel's visibility in step.
  window.hfsSetAccordion = function (item, open, instant) {
    var $item = $(item);
    var $button = $item.find('.accordion_toggle').first();
    var $panel = $('#' + $button.attr('aria-controls'));
    if (!$panel.length) $panel = $item.children('.accordion_content');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    $button.attr('aria-expanded', open ? 'true' : 'false');
    $item.toggleClass('active', open);
    $panel.stop(true, true);
    if (instant || reduce) $panel.toggle(open);
    else if (open) $panel.slideDown();
    else $panel.slideUp();
  };
  $('.accordion-panel .accordion_item').each(function (index) {
    window.hfsSetAccordion(this, index === 0, true);
  });
  $('.accordion-panel .accordion_toggle').on('click', function () {
    window.hfsSetAccordion($(this).closest('.accordion_item')[0], $(this).attr('aria-expanded') !== 'true');
  });

  // HFS a11y (demand item c; PDP-13/JS-03/PDP-15): PDP in-page nav. Opens the section, scrolls, moves focus
  // to the target heading (window.hfsJumpTo) and marks the current link with aria-current as well as .active.
  var $pdpNavLinks = $('.product-description .navi_links ul.links a');
  $pdpNavLinks.first().addClass('active').attr('aria-current', 'true');
  $pdpNavLinks.on('click', function (e) {
    if (!window.hfsJumpTo(this.getAttribute('href'))) return;
    e.preventDefault();
    $pdpNavLinks.removeClass('active').removeAttr('aria-current');
    $(this).addClass('active').attr('aria-current', 'true');
  });
  // Hide nav links whose target is not on the page (e.g. no recently viewed products, no recommendations).
  function hfsSyncPdpNav() {
    $pdpNavLinks.each(function () {
      var target = document.getElementById((this.getAttribute('href') || '').replace(/^#/, ''));
      var shown = !!target && (target.closest('.accordion_item') || target.getClientRects().length > 0) &&
        !$(target).hasClass('no-rel-product-grid');
      $(this).closest('li').prop('hidden', !shown);
    });
  }
  if ($pdpNavLinks.length) {
    hfsSyncPdpNav();
    $(window).on('load', hfsSyncPdpNav);
    setTimeout(hfsSyncPdpNav, 4000);
    // HFS (audit 2026-10-01, C03): sections can appear later than the timers above (the recently viewed grid renders
    // after a preferences opt-in), so re-sync on consent changes and whenever a target section's content changes.
    var hfsNavSyncTimer = null;
    function hfsScheduleNavSync() {
      clearTimeout(hfsNavSyncTimer);
      hfsNavSyncTimer = setTimeout(hfsSyncPdpNav, 50);
    }
    if (window.HFSConsent && typeof window.HFSConsent.onChange === 'function') window.HFSConsent.onChange(hfsScheduleNavSync);
    if (typeof MutationObserver === 'function') {
      $pdpNavLinks.each(function () {
        var target = document.getElementById((this.getAttribute('href') || '').replace(/^#/, ''));
        if (target) new MutationObserver(hfsScheduleNavSync).observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
      });
    }
  }
  // Select all span elements within list items
  var spans = $('.product-description .accordion-panel .accordion_content .product_mata_info ul li');
  // Loop through each span element
  spans.each(function () {
    // Get the text content of the span
    var text = $(this).text();

    // Extract the first character
    var firstCharacter = text.charAt(0);

    // Output the first character (you can do something else with it)
    // HFS a11y (PDP-18): the decorative initial must not be read aloud ("A Arch support")
    $(this).prepend('<span aria-hidden="true">' + firstCharacter + '</span>')
  });
  // HFS a11y (JS-15/CNT-15/TPL-19): FAQ/Q&A and Shoe Glossary letter links, and form error-summary links
  // (the target is the field itself, so focus lands in it). All go through window.hfsJumpTo.
  $('.qa-content .description li a,.shoe_glossary .short_description .description > p > a, form h2.form__message + ul li a').on('click', function (e) {
    if (window.hfsJumpTo(this.getAttribute('href'))) e.preventDefault();
  });

  $('.submit-address button[type="reset"]').click(function () {
    $("html").animate({ scrollTop: 0 }, "slow");
  });
  /* Recently viewed product slider */
  window.hfsCarousel($('.recently-viewed-wrapper .recently-viewed-grid'), {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {

          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }, { label: 'recently viewed products' });
  // HFS (JS-25): the related-products carousel starts when the recommendations arrive. ProductRecommendations
  // (global.js) dispatches 'hfs:recommendations-loaded' after it fills in; this replaces a 500 ms poll that ran
  // forever on pages where recommendations never load (they are fetched only when scrolled near).
  function hfsInitRelatedCarousel() {
    if (!$('.product-recommendations--loaded').length) return;
    var $relatedGrid = $('.related-products .product-grid').not('.slick-initialized');
    if (!$relatedGrid.length) return;
      window.hfsCarousel($relatedGrid, {
        dots: false,
        infinite: false,
        arrows: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 575,
            settings: {

              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }, { label: 'related products' });
  }
  hfsInitRelatedCarousel();
  document.addEventListener('hfs:recommendations-loaded', hfsInitRelatedCarousel);

  /* Product Detail popup */

  $('.product-description .accordion_content .product_mata_info ul span.metafield-multi_line_text_field').contents().unwrap();
  $(".product-description .product_mata_info li").each(function (index) {
    var liTextContent = $(this).contents().filter(function () {
      return this.nodeType === Node.TEXT_NODE;
    }).text();
    $(this).contents().filter(function () {
      return this.nodeType === Node.TEXT_NODE;
    }).remove();
    // HFS a11y (PDP-17/JS-06): a real button (keyboard + screen reader), not a click-only <strong>
    $(this).append($('<button type="button" class="ImgModal" data-group="" aria-haspopup="dialog"></button>').text(liTextContent.trim().replace(/\s+/g, ' ')));

  });

  $(".product-description .product_mata_info.features li").each(function (index) {
    var features = $(this).find(".ImgModal");
    features.attr("data-group", "feature");

  });

  $(".product-description .product_mata_info.condition li").each(function (index) {
    var features = $(this).find(".ImgModal");
    features.attr("data-group", "condition");

  });
  var termDescriptions = {};
  var termDescriptionsNode = document.getElementById('product-term-descriptions');
  if (termDescriptionsNode) {
    try { termDescriptions = JSON.parse(termDescriptionsNode.textContent); }
    catch (err) { console.error('Product term descriptions could not be loaded', err); }
  }
  $(".ImgModal").on('click', function () {
    var cat = $(this).data('group');
    var term = $(this).text().trim();
    var descriptName = term.toLowerCase().replace(/\s+/g, "");
    descriptName = descriptName.replaceAll("-", "");
    descriptName = descriptName.replaceAll("/", "");
    descriptName = descriptName.replaceAll("(", "");
    descriptName = descriptName.replaceAll(")", "");
    descriptName = descriptName.replaceAll("'", "");
    descriptName = descriptName.replaceAll(",", "");
    var imagemodal = document.getElementById('image-modal');
    var description = termDescriptions[cat + ':' + descriptName];
    $('#image-modal-title').text(term);
    $('#image-modal-description').text(
      typeof description === 'string' && description.trim()
        ? description
        : 'More information about this term is not available yet.'
    );
    // ModalDialog.show() traps focus in the dialog, closes on Escape and returns focus to this button on close
    if (imagemodal && typeof imagemodal.show === 'function') imagemodal.show(this);
    else if (imagemodal) imagemodal.setAttribute('open', 'open');
  });

  // Announcements: mobile shows one message at a time in a native sideways-scrolling row (hfs-carousel.css) from
  // first paint; this only adds its arrows, dots and edge fades. Slick is needed only on tablets, and it never
  // autoplays (the owner dropped the rotation and its Pause button on 2026-10-13), so the visitor moves it.
  // Re-entering that range uses Slick directly after the first hfsCarousel call: its accessibility listeners and
  // saved tabindex values survive unslick, so they must not be installed repeatedly.
  (function () {
    if (!window.matchMedia || document.documentElement.classList.contains('shopify-design-mode')) return;
    var mobile = window.matchMedia('(max-width: 766.98px)');
    var tablet = window.matchMedia('(min-width: 767px) and (max-width: 1284.98px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var options = {
      dots: false,
      infinite: true,
      arrows: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      pauseOnFocus: false, // both default to on and make Slick start an idle interval on focus or hover
      pauseOnHover: false,
      responsive: [
        { breakpoint: 99999, settings: 'unslick' },
        { breakpoint: 1285, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 1023, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 767, settings: 'unslick' }
      ]
    };
    $('.announce_slider').each(function () {
      var $slider = $(this);
      var row = this;
      var main = this.closest('.announce_main');
      var enhanced = false;
      // Phones: arrows at the bar's edges step one message at a time (swiping still works), and dots under the row
      // show how many messages there are and which one is showing. The dots are decorative: the links and arrows
      // are what the keyboard and screen readers reach. An edge fades while more messages lie beyond it.
      var items = row.querySelectorAll('.announce_slider__flex');
      var dots = [], arrows = {};
      function step() { return items[0].offsetWidth || row.clientWidth; }
      function phone() { return mobile.matches && !$slider.hasClass('slick-initialized'); }
      if (main && items.length > 1) {
        ['prev', 'next'].forEach(function (dir) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'announce_arrow announce_arrow--' + dir;
          btn.setAttribute('aria-label', (dir === 'prev' ? 'Previous' : 'Next') + ' announcement');
          btn.addEventListener('click', function () {
            if (btn.getAttribute('aria-disabled') === 'true') return;
            var left = (dir === 'prev' ? -1 : 1) * step();
            if (row.scrollBy) row.scrollBy({ left: left, behavior: reduced.matches ? 'auto' : 'smooth' });
            else row.scrollLeft += left;
          });
          main.appendChild(btn);
          arrows[dir] = btn;
        });
        var dotBar = document.createElement('div');
        dotBar.className = 'announce_dots';
        dotBar.setAttribute('aria-hidden', 'true');
        for (var d = 0; d < items.length; d++) dots.push(dotBar.appendChild(document.createElement('span')));
        main.appendChild(dotBar);
      }
      function syncEdges() {
        var on = phone();
        var atStart = row.scrollLeft <= 1, atEnd = row.scrollLeft >= row.scrollWidth - row.clientWidth - 1;
        row.classList.toggle('is-scrolled', on && !atStart);
        row.classList.toggle('is-end', on && atEnd);
        if (arrows.prev) arrows.prev.setAttribute('aria-disabled', String(atStart));
        if (arrows.next) arrows.next.setAttribute('aria-disabled', String(atEnd));
        var page = on && step() ? Math.round(row.scrollLeft / step()) : 0;
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === page); });
      }
      function syncAnnouncements() {
        var active = document.activeElement;
        var focusWasInSlider = !!(main && main.contains(active));
        if (tablet.matches && $.fn.slick) {
          if (!$slider.hasClass('slick-initialized')) {
            if (!enhanced) {
              window.hfsCarousel($slider, options, { label: 'announcements' });
              enhanced = $slider.hasClass('slick-initialized');
            } else {
              $slider.slick(options);
            }
          }
        } else if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
        // A resize must not drop or strand keyboard focus: Slick moves the messages (which blurs the focused one), and
        // unslick removes its arrows and cloned slides.
        if (focusWasInSlider) {
          var gone = !document.contains(active) || (!tablet.matches && active.matches('.slick-arrow')) ||
            active.getAttribute('tabindex') === '-1' || !!active.closest('[aria-hidden="true"]'); // now on a hidden slide
          var target = gone ? $slider[0].querySelector('a[href]:not([tabindex="-1"])') : active;
          if (target && document.activeElement !== target) target.focus({ preventScroll: true });
        }
        syncEdges();
      }
      syncAnnouncements();
      [mobile, tablet].forEach(function (query) {
        if (query.addEventListener) query.addEventListener('change', syncAnnouncements);
        else if (query.addListener) query.addListener(syncAnnouncements);
      });
      row.addEventListener('scroll', syncEdges, { passive: true });
      // Tab: Chrome leaves a half-visible link where it is, so bring the focused message fully clear of the fades.
      row.addEventListener('focusin', function (e) {
        var item = phone() && e.target.closest('.announce_slider__flex');
        if (!item) return;
        var style = getComputedStyle(row), box = row.getBoundingClientRect(), r = item.getBoundingClientRect();
        var right = box.right - parseFloat(style.scrollPaddingRight || 0), left = box.left + parseFloat(style.scrollPaddingLeft || 0);
        if (r.right > right) row.scrollLeft += Math.min(r.right - right, r.left - left);
        else if (r.left < left) row.scrollLeft -= left - r.left;
      });
      window.addEventListener('resize', syncEdges);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncEdges); // web fonts change the width
    });
  })();


  // footer accordion (audit CSS-06/JS-11, WCAG 2.1.1 / 4.1.2).
  // At <=850px each footer heading gets a real <button aria-expanded aria-controls> so the link lists can be opened from the keyboard.
  // Above 850px the lists are always visible and the heading is plain text. Progressive enhancement: without JS (or if this throws) every list stays visible.
  (function () {
    var cols = document.querySelectorAll(".col_menu_all");
    if (!cols.length || !window.matchMedia) return;
    var mq = window.matchMedia("(max-width: 850px)");

    function setOpen(col, open) {
      var btn = col.querySelector(".ft_heading__btn");
      var heading = col.querySelector(".ft_heading");
      col.classList.toggle("is-open", open);
      if (btn) btn.setAttribute("aria-expanded", open ? "true" : "false");
      if (heading) heading.classList.toggle("active", open);
    }

    function enhance(col, index) {
      var heading = col.querySelector(".ft_heading");
      var list = col.querySelector("ul");
      if (!heading || !list || heading.querySelector(".ft_heading__btn")) return;
      if (!list.id) list.id = "ft-menu-" + index;
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ft_heading__btn";
      btn.setAttribute("aria-expanded", "false");
      btn.setAttribute("aria-controls", list.id);
      btn.textContent = heading.textContent.trim();
      heading.textContent = "";
      heading.appendChild(btn);
      col.classList.add("is-collapsible");
      btn.addEventListener("click", function () {
        var opening = btn.getAttribute("aria-expanded") !== "true";
        Array.prototype.forEach.call(cols, function (other) { setOpen(other, false); });
        setOpen(col, opening);
      });
    }

    function unenhance(col) {
      var heading = col.querySelector(".ft_heading");
      var btn = heading && heading.querySelector(".ft_heading__btn");
      if (btn) {
        heading.textContent = btn.textContent;
        heading.classList.remove("active");
      }
      col.classList.remove("is-collapsible", "is-open");
    }

    // HFS (audit 2026-10-01, B09): a breakpoint change must not strand keyboard focus. Widening removed the focused
    // heading button (focus fell to the document); narrowing hid a focused link inside a newly collapsed list.
    function apply() {
      var active = document.activeElement;
      Array.prototype.forEach.call(cols, function (col, i) {
        var hadFocus = !!active && active !== document.body && col.contains(active);
        if (mq.matches) {
          enhance(col, i + 1);
          var btn = col.querySelector(".ft_heading__btn");
          if (hadFocus && active !== btn) setOpen(col, true); // the focused link stays visible
        } else {
          var oldBtn = col.querySelector(".ft_heading__btn");
          var buttonFocused = !!oldBtn && active === oldBtn;
          unenhance(col);
          if (buttonFocused) {
            var heading = col.querySelector(".ft_heading");
            if (heading) {
              heading.setAttribute("tabindex", "-1");
              heading.focus();
            }
          }
        }
      });
    }

    apply();
    if (mq.addEventListener) mq.addEventListener("change", apply);
    else if (mq.addListener) mq.addListener(apply);
  })();
  // footer form placeholder: now set once when the Constant Contact widget renders (sections/footer.liquid). GLB-18
  // (hover-only .desktop_mega_menu handlers removed: dead code, section ctm-mega-menu is disabled, and they had no keyboard equivalent)

  // add dropdown in megamenu
  var menuRels = $('.ctm_header_nav_menu ul li a').attr('data-dropdown-rel');
  var dropRels = $('.desktop_mega_menu').attr('data-dropdown');

  $('.ctm_header_nav_menu ul li a[data-dropdown-rel="' + dropRels + '"]').addClass('dropdown');

  // color swatches
  // HFS (JS-25): removed the timed removals (after 3 s and 7 s) of swatch groups without labels and of
  // label.hidden. snippets/card-product.liquid now renders .ctm_variant_div only for products with a colour
  // option and gives every swatch radio a label, so both were no-ops that could fire mid-interaction.
  $(document).on('change', '.ctm_variant_div input[type="radio"]', function (e) {
    var variant_img_src = $(e.currentTarget).attr('data-image');

    if (variant_img_src) {
      // HFS (WAVE-HOME-03, 2026-10-01): only the product images inside .media change. The HSA/FSA badge is also an
      // <img> inside .card__media and used to be overwritten with the shoe photo (and given the shoe's alt).
      var $cardImages = $(e.currentTarget).closest('.card-wrapper').find('.card__media .media img');
      // HFS (general review 2026-10-01): keep each card image's responsive widths (global.js hfsSwapImage) instead of
      // one URL in src and srcset, which made the browser load that single image at whatever size it was.
      $cardImages.each(function () {
        if (window.hfsSwapImage) window.hfsSwapImage(this, variant_img_src);
        else { this.setAttribute('src', variant_img_src); this.removeAttribute('srcset'); }
      });
      // HFS a11y (COL-08/JS-23): keep the primary image's alt in step with the image shown (data-alt from
      // snippets/card-product.liquid: the variant image's own alt, or "" when the card title already names it).
      $cardImages.first().attr('alt', $(e.currentTarget).attr('data-alt') || '');
    }
    // HFS (SC11): the card's links follow the chosen colour (global.js)
    if (window.hfsCardColourLinks) window.hfsCardColourLinks(e.currentTarget);
  });

  // HFS a11y (PDP-24/JS-09/COL-34): the mouse-only .view_eye "quick view" (it clicked the card's hidden quick-add submit, and
  // was display:none anyway) was removed from snippets/card-product.liquid together with this handler. Do not re-add.

  // HFS (JS-26): removed the li.ctm_recent_li block that appended class names to input ids and label "for"
  // values (ids with spaces). No markup in the theme has that class.

  // hide element if more than 5 
  // if ($('.ctm_variant_spans').length > 5) {
  //   $('.ctm_variant_spans:nth-child(n+6)').hide();
  //   $('.ctm_variant_spans:nth-child(n+6)').parent().next().show();
  // }
  
// Function to handle the display of items
function handleVariantDisplay() {
    $('.grid__item').each(function () {
        // Get the repeated .ctm_variant_spans elements within the .ctm_variant_div_span of the current .grid__item
        const $ctmVariantSpans = $(this).find('.ctm_variant_div_span .ctm_variant_spans');
        const $viewMoreDiv = $(this).find('.view--more');

        if ($ctmVariantSpans.length > 5) {
            // Show only the first 5 items
            $ctmVariantSpans.slice(0, 5).show();
            $ctmVariantSpans.slice(5).hide();

            // Ensure .view--more is visible
            $viewMoreDiv.show();

            // Add click event to the view-more button (HFS a11y COL-05/JS-10: it is a <button> now; bound once,
            // and focus moves to the first revealed colour before the button is hidden)
            $viewMoreDiv.attr('aria-expanded', 'false');
            $viewMoreDiv.off('click.hfsViewMore').on('click.hfsViewMore', function() {
                // Show all hidden items
                $ctmVariantSpans.slice(5).show();
                $viewMoreDiv.attr('aria-expanded', 'true');
                $ctmVariantSpans.eq(5).find('input').first().trigger('focus');

                // Hide the .view--more button after showing all items
                $viewMoreDiv.hide();
            });
        } else {
            // Show all items if there are 5 or fewer
            $ctmVariantSpans.show();

            // Remove .view--more if items are 5 or fewer
            $viewMoreDiv.remove();
        }
    });
}

// Initially handle the variant display
handleVariantDisplay();

// Re-run the variant display function after facets.js re-renders the product grid.
// facets.js dispatches 'hfs:facets-updated' on document once the new grid is in the DOM.
// (Previously this was a click handler on every element in #FacetFiltersForm that called
// stopPropagation(), which blocked document-level click handlers such as outside-click menu close.)
document.addEventListener('hfs:facets-updated', function() {
    handleVariantDisplay();
});
  

  // HFS a11y (JS-15/CNT-15): resource-center A-Z index; opens the letter's <details>, scrolls and moves focus.
  $('.accordion__content .alpha-index a').on('click', function (event) {
    event.preventDefault();
    $('.accordion__content .alpha-index a').removeClass('active').removeAttr('aria-current');
    $(this).addClass('active').attr('aria-current', 'true');
    window.hfsJumpTo(this.getAttribute('href'));
  });
  $('.cust-collapsible.resource-center details').attr('open', true);
  $('.ctm_collapsibles__accordion details summary').each(function (index) {
    $(this).on('click', function () {
      // Set the target element
      var targetElement = $(this).parent('details');
      // Close other details elements
      var headerheight = $('.fixed-announce').height();
      if ($(this).parent('details').attr('open') !== undefined) {
        $(this).parent('details').attr('open', true);


      } else {
        $(this).parent('details').attr('open', false);
        $('html, body').animate({
          scrollTop: targetElement.offset().top - headerheight
        }, 1000);
      }

    });
  });



  $('.ctm_header_icons .search-modal__form .field input').focus(function () {
    // Add a class to the body tag
    //$('body').addClass('suggestion-open');
  });

  // When clicking outside the input field
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.ctm_header_icons .search-modal__form .field input').length) {
      // Remove the class from the body tag
      $('body').removeClass('suggestion-open');
    }
  });

  // Get the list items
  $('.product-description .accordion_content .product_mata_info ul').each(function (index) {
    var $listItems = $(this).children("li");

    // Sort the list items based on the first word
    $listItems.sort(function (a, b) {
      var textA = $(a).text().trim().split(' ')[0].toLowerCase();
      var textB = $(b).text().trim().split(' ')[0].toLowerCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });

    // Re-append the sorted list items to the list
    $(this).append($listItems);
  });

/* Header Mega Menu: the overlay (body.hovered), the summary's .active class and aria-expanded all follow
   the <details> open state. Mouse, keyboard (Enter/Space/Escape) and focus-out all change `open`, and the
   `toggle` event fires for every one of them, so the overlay can no longer get stuck on after Escape. */
var megaMenus = $(".ctm_header_nav_menu ul details.mega-menu");
megaMenus.on('toggle', function () {
  if (this.hasAttribute('open')) {
    // only one panel at a time
    megaMenus.not(this).removeAttr('open');
  }
  megaMenus.each(function () {
    var isOpen = this.hasAttribute('open');
    $(this).children('summary').toggleClass('active', isOpen).attr('aria-expanded', isOpen ? 'true' : 'false');
  });
  $('body').toggleClass('hovered', megaMenus.filter('[open]').length > 0);
});

$(document).on('click', function (event) {
    // Check if the click is outside the specified element
    if (!$(event.target).closest('.ctm_header_nav_menu ul details.mega-menu').length && !$(event.target).closest('.close-megamenu').length) {
        $('.mega-menu').removeAttr('open');
    }
});

// Close button (a real <button>): close the panel and return focus to its summary
$('.close-megamenu').on('click', function () {
    var details = $(this).closest('details.mega-menu');
    details.removeAttr('open');
    details.children('summary').attr('aria-expanded', 'false').removeClass('active').trigger('focus');
    $('body').removeClass('hovered');
});

/* End */  

  $('.product-form__input input[type=radio]').on('click', function () {
    // Get the selected color value (HFS: display name without the internal "(1)" suffix)
    var selectedColor = $(this).attr('data-label') || $(this).val();
    // Update the text of the selected-variant-color-label
    // (only the "selected value" span: a bare 'span' also overwrote the "Please select an option" error text)
    $(this).siblings('.form__label').find('span[id^="selected-variant-"]').text(selectedColor);
  });

  // Iterate over each set of elements with class "jdgm-rev__scale-range"
  setTimeout(() => {
    $('.jdgm-rev__scale-range').each(function () {
      // Find the elements with the class "jdgm--empty"
      var emptyElements = $(this).find('.jdgm-cf-bar.jdgm--filled');
      // Count the elements with the class "jdgm--empty"
      var emptyCount = emptyElements.length;
      // Add the same class to the first element with the class "jdgm--empty"
      emptyElements.last().addClass('last-empty');
    });
  }, 5000);



  // Removed: the script that pre-selected and kept re-checking "True To Size" / "True To Width" / "Good Support"
  // in the Judge.me review form (FTC 16 CFR 465). Review-form questions must start unanswered; do not re-add.

  /* PDP Pages You May Also like JS */

  // $('#you-may-also-like .mf-1').parents('.related-li').addClass('em-related-li');
  // $('#you-may-also-like .em-related-li').remove();

  // $('#you-may-also-like ul.grid.product-grid').each(function () {
  //     // Check if "product-grid" class exists in the children of this list item
  //     if ($(this).find('li.related-li').length === 0) {
  //       // If not found, add a class to the main parent (ul)
  //       $(this).parents('#you-may-also-like').addClass('no-rel-product-grid');
  //     }
  // });

  // HFS (JS-25): runs once now and again when recommendations arrive, instead of a 500 ms poll that never
  // stopped on pages without the #you-may-also-like grid.
  function runAtIntervals() {
    // First action
    $('#you-may-also-like .mf-1').parents('.related-li').addClass('em-related-li');
    $('#you-may-also-like .em-related-li').remove();

    // Second action
    $('#you-may-also-like .grid.product-grid').each(function () {
      // Check if "product-grid" class exists in the children of this list item
      if ($(this).find('.related-li').length === 0) {
        // If not found, add a class to the main parent (ul)
        $(this).parents('#you-may-also-like').addClass('no-rel-product-grid');
      }
    });
  }

  runAtIntervals();
  document.addEventListener('hfs:recommendations-loaded', runAtIntervals);


  // HFS a11y (JS-16/COL-11): the old setInterval here stripped tabindex from every Judge.me badge in a slick slide
  // (visible ones too) and forced aria-hidden="false" on announcement slides, once. assets/hfs-carousel.js now
  // keeps hidden slides and clones out of the tab order and restores them when visible. Do not re-add.


    // HFS a11y (PDP-06): removed the thumbnail-click handler that copied the 416px thumbnail src into the active
    // slide (keeping that slide's alt). media-gallery.js already activates the real slide, which has its own
    // correct src and alt. Do not re-add.

  // Document Ready Closed
});

// HFS (preview fixes 2026-09-30): the Size chart / Width chart / How to measure dialog code moved to
// assets/hfs-guide-dialog.js (loaded by sections/main-product.liquid). Do not re-add it here.
document.addEventListener("DOMContentLoaded", function () {
    // Select the details elements
    const detailsElements = document.querySelectorAll(".custom_facets facet-filters-form.facets.small-hide form details");

    // Add the 'open' attribute to each details element
    detailsElements.forEach(details => {
        details.setAttribute("open", "open");
    });
});
